import { getQueryParam, setCookie } from "../utils"

const hubSpotBannedEmails = [
    'YXJrYW5nZWwtMTBAb3V0b2xvb2suY29t',
    'Y2xvcm9maWxhLTI3QG91dG9sb29rLmNvbQ==',
]

window.onHubSpotFormSubmitted = function(formName, formId, $form, enableShare, analytics) {
    formName = formName || 'content'
    $form.closest(".hbspt-form").addClass("submitted")
    const $formWrap = $form.closest('.js-hubspot-form-wrap')

    if ($formWrap.length) {
        const $beforeSubmit = $formWrap.find('.js-hubspot-form-before-submit');
        const $afterSubmit = $formWrap.find('.js-hubspot-form-after-submit');
        $beforeSubmit.remove();
        $afterSubmit.removeClass('d-none');
    } else {
        if (enableShare) {
            try {
                setTimeout(() => {
                    $form
                    .append(`
                        <div class="text-bold mt-4">Share the knowledge!</div>
                        <div class="share share_darkblue share_center likely mt-2">
                            <div class="share__item share__item_fb facebook" tabindex="0" role="link" aria-label="Share on Facebook"></div>
                            <div class="share__item share__item_tw twitter" tabindex="0" role="link" aria-label="Tweet on Twitter"></div>
                            <div class="share__item share__item_li linkedin" tabindex="0" role="link" aria-label="Share on LinkedIn"></div>
                            <a href="mailto:?body=${location.origin + location.pathname}&subject=${document.title}" class="share__item share__item_email" tabindex="0" role="link" aria-label="Send via Email"></a>
                        </div>
                    `)
                    likely.initiate()
                })
            } catch(e) { console.log(e) }
        }
    }

    if (formName.startsWith('report_')) {
        const reportId = $formWrap.data('report-id')
        const firstChapterUrl = $formWrap.data('report-first-chapter-url')
        if (reportId && firstChapterUrl) {
            setCookie(`sm_report_${reportId}`, JSON.stringify({ unlocked: true }), 99999)
            window.open(firstChapterUrl, '_blank')
        }
    }

    if (formName === 'demo' 
        || formName === 'demoNoSelect'
        || formName === 'mauVegas'
        || formName === 'demoAcquireSelfService') {
        jQuery('body').addClass('form-submitted')
    } else if (formName === "blogSubscriptionRevealContent" 
        || formName === "blogSubscription") {
        var $subscribersOnly = jQuery('.js-subscribers-only')
        $subscribersOnly
            .find('.js-subscribers-only-form')
            .slideUp()
        $subscribersOnly
            .find('.js-subscribers-only-content')
            .slideDown()

        try {
            setCookie("sm_is_blog_subscribed", 1, 9999)
        } catch(e) { console.log(e) }
    } else if (formName === 'appGrowthWeek2023') {
        jQuery('.agw23-modal').addClass('agw23-modal--submitted')
    }

    if (analytics) {
        try {
            const analyticsFormName = formName === "demo" || formName === "demoNoSelect" ? "demo" : formName
            dataLayer.push({
                event: 'form_submitted',
                ec: 'form_submitted',
                ea: 'form',
                el: analyticsFormName,
            })
        } catch(e) { console.log(e) }
    }
}

window.onHubSpotFormReady = function($form) {
    if ($form.closest('.js-hubspot-form').length === 0) return
    
    // prefill utm fields
    $form.serializeArray().map(function(x) {
        if (x.name.indexOf('utm_') !== 0) return
        let cookie_val = Cookies.get(x.name)
        if (cookie_val && cookie_val != ''){
            $form.find('input[name="'+x.name+'"]').val(cookie_val).change();
        }	
    })

    const $formEmailInputs = $form.find('input[name="email"]')

    $formEmailInputs.on('change paste keyup', function(e) {
        const valueToCheck = e.type === "paste" ? e.originalEvent.clipboardData.getData('text') : null
        const $input = jQuery(this)
        checkHubSpotFormsForBannedEmails(jQuery($input), valueToCheck)
    })

    checkHubSpotFormsForBannedEmails($formEmailInputs)

    var formName = $form.closest('.js-hubspot-form').data('name')
    if (formName === 'demo' || formName === 'demoNoSelect') {
        const prQueryParam = getQueryParam('pr')
        const currentProduct = $('body').data('product')
        $form.find('input[name=product_demo_requested]')
            .va(prQueryParam && currentProduct !== 'spl' ? prQueryParam : 'spl')
            .change()
    }

    if (typeof ga !== "undefined") {
        const $cidInput = $form.find("input[name=cid]")
        ga(function() {
            var clientId = ga.getAll()[0].get('clientId');
            if ($cidInput.length && clientId) {
                $cidInput
                    .val(clientId)
                    .change()
            }
        })
    }
}

function checkHubSpotFormsForBannedEmails($inputs, valueToCheck) {
    $inputs.each(function() {
        const $input = jQuery(this)
        if (!hubSpotBannedEmails.includes(btoa(valueToCheck ? valueToCheck.trim() : $input.val().trim()))) {
            return
        }

        $input.blur()
        const $form = $input.closest('.hs-form')
        $form.find('input[type="submit"]').remove()
    })
}

checkHubSpotFormsForBannedEmails(jQuery('.hs-form input[name="email"]'))
